import { ColDef, ColGroupDef } from "ag-grid-community";
import { PriceGroupsStoreView } from "models/dbModels/priceGroups/PriceGroupsStore";
import { useState } from "react";
import { Form } from "react-bootstrap";
import { Spinner } from "components";
import { useAppDispatch } from "redux/hooks";
import { bulkUpdatePriceGroupsStore, updateAssignPriceGroupTableField } from "redux/slices/AssignPriceGroup";
import { displayTooltipsIcons } from "helpers/data/dataHandling";
import { Link } from "react-router-dom";
 
export function getPriceGroupStoreConfig(assignPriceGroup: any, user: any, priceGroups: any): (ColDef<PriceGroupsStoreView> | ColGroupDef<PriceGroupsStoreView>)[] | null {        
    return [
        {
            checkboxSelection: true,
            headerCheckboxSelection: true,
            width: 45,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
        },
        {
            headerName: "Name",
            field: "storeName",
            initialSort: "asc",
            flex: 1,
            cellClass: "aggrid-header-link-lext cursor-pointer",
            minWidth: 200,
            suppressHeaderMenuButton: true,
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {
                                children: <Link to={''} >{params.data?.storeName}</Link>,
                            }
                }
            },
        },
        {
            headerName: "Current Price Group",
            flex: 1,
            minWidth: 180,
            suppressHeaderMenuButton: true,
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {
                        children: <div>{params.data?.priceGroupName}{displayTooltipsIcons(params.data?.priceGroupName!)}</div>
                    }
                }
            }
        },
        {
            headerName: "New Price Group",
            flex: 3,
            field: "newPriceGroupId",
            minWidth: 200,
            suppressHeaderMenuButton: true,
            cellRendererSelector: (params) => {
                return {
                    component: 'baseCellRenderer',
                    params: {
                                children: <PriceGroupDropdown assignPriceGroup={assignPriceGroup} data={params.data as PriceGroupsStoreView} priceGroups={priceGroups} user={user}/>,
                            }                   
                }
            }
        }
    ];
}

type priceGroupDropdownProps = {data: PriceGroupsStoreView, assignPriceGroup: any, user: any, priceGroups: any}
const PriceGroupDropdown = ({data, assignPriceGroup, user, priceGroups}: priceGroupDropdownProps) => {
    const dispatch = useAppDispatch(); 
    const tooltipType: string | undefined = data?.newPriceGroupId === -1 ? "Base Sell Price" : data.newPriceGroupId  === -2 ? "Mixed" : data.newPriceGroupId?.toString();
    const [storeValue, setStoreValue] = useState(data.newPriceGroupId  ? data.newPriceGroupId  : "Mixed");
    const [loadingValue, setLoadingValue] = useState(false);
    async function handleStoreUpdate(newStoreValue: number) {
    setLoadingValue(true);
        await dispatch(bulkUpdatePriceGroupsStore({
            storeIds: [data.storeId],
            newPriceGroupId: newStoreValue
        })).then((res) => {
            if (res.data) {
                setStoreValue(newStoreValue);
                const index = assignPriceGroup.stores.findIndex((store: any) => store.storeId === data.storeId);
                dispatch(updateAssignPriceGroupTableField({ field: "stores", index: index, key: "newPriceGroupId", value: newStoreValue }));
            }
        }).catch((error) => {
        });
        setLoadingValue(false);
    }
    return (
        <div style={{ maxWidth: "250px", display: "flex" }}>
            {loadingValue ?
                <span><Spinner className="spinner-border-sm me-1" tag="span" color="primary" />Saving... </span>
                : <>
                    <Form.Group style={{ margin: "-3px 0px" }}>
                        <Form.Select
                            className="custom-select"
                            value={storeValue}
                            onChange={(e) => handleStoreUpdate(parseInt(e.target.value))}
                            disabled={!user.permissions.assignPriceGroups.canUpdate}
                        >
                            <option value={0}></option>
                            <option value={-1}>Base Sell Price</option>
                            <option value={-2} hidden>Mixed</option>
                            {priceGroups.table.map((priceLevel: any, index: any) => {
                                return <option key={index} value={priceLevel.id}>{priceLevel.name}</option>
                            })}
                        </Form.Select>
                    </Form.Group>
                 
                </>
            }
        </div>
    );
};
